// extracted by mini-css-extract-plugin
module.exports = {"nav__list":"NavGroup_nav__list__fY2uX","nav__submenu-list":"NavGroup_nav__submenu-list__B5uZM","nav__submenu-label":"NavGroup_nav__submenu-label__tsLI0"};